import * as PIXI from 'pixi.js'
import { 
  KpiWindow,
  getLinkLine,
  getLine,
  getLinkLineBus,
  //getLinkAnimation,
  getContactor,
  getNodeBackground,
  getNodeDescription,
  getNodeMoreInfoBtn,
  getNodeSprite,
  getNodeTitle,
  getStatusLed,
  getCGM,
  getCBT,
  getAlarm
  //getNodeCircleAnimation,
} from './graphic-controls'
import RawDataService from '../services/RawDataServiceTemplate';
const NODE_MAIN_SIZE = 220;
const NODE_AUX_SIZE = 140;
const NODE_SMALL_SIZE = 180;

const CANVAS_MIN_BOT_BORDER = 80;
const CANVAS_DEFAULT_HEIGHT = 1000;
const BUS_WIDTH=60;



/**
 * {{ main: number, derDc: number, derAc: number, loads: number}} state for number of graphic subnodes, for location assignment
 */
 const nodeCounters = {
  MAIN_GROUP: 0,
  MAIN_GROUP_GW:0,
  MAIN_GROUP_PV_S:0,
  MAIN_GROUP_PV_I:0,
  MAIN_GROUP_RACKS:0,
  MAIN_GROUP_BATTS:0,
  MAIN_GROUP_PCS:0,
  MAIN_GROUP_CGM_PCS:0,
  MAIN_GROUP_LOADS:0,
  MAIN_GROUP_GRID:0,
  DER_AC: 0,
  DER_DC: 0,
  LOADS_R:0,
  LOADS_L: 0,
  BUS: 0,
  BATT:0,
}

/**
 * reset node counters object to zeros
 */
const resetNodeCounters = () => {
  nodeCounters.MAIN_GROUP=0;
  nodeCounters.MAIN_GROUP_GRID=0;
  nodeCounters.MAIN_GROUP_GW=0;
  nodeCounters.MAIN_GROUP_PV_S=0;
  nodeCounters.MAIN_GROUP_PV_I=0;
  nodeCounters.MAIN_GROUP_RACKS=0;
  nodeCounters.MAIN_GROUP_BATTS=0;
  nodeCounters.MAIN_GROUP_PCS=0;
  nodeCounters.MAIN_GROUP_CGM_PCS=0;
  nodeCounters.MAIN_GROUP_LOADS = 0;
  nodeCounters.DER_AC=0;
  nodeCounters.DER_DC=0;
  nodeCounters.LOADS_R=0;
  nodeCounters.LOADS_L=0;
  nodeCounters.BUS=0; 
  nodeCounters.BUS_NODES=0;
  nodeCounters.BATT=0;
  nodeCounters.BATT_String=0;
}

/**
 * get canvas sizes according to calcs from attachGraphics
 * @returns {{MAIN_GROUP: number, DER_AC: number, DER_DC: number, LOADS: number}}
 */
const getCanvasHeights = () =>{
  const mainProps = { maxEl: 1, tabSize: 280, initMargin: 30 };
  const acProps = { maxEl: 1, tabSize: 440, initMargin: 160 };
  const dcProps = { maxEl: 1, tabSize: 440, initMargin: 160 };
  const loadProps1 = { maxEl: 1, tabSize: 440, initMargin: 160 };
  const loadProps2 = { maxEl: 1, tabSize: 220, initMargin: 160 };
  const busProps = { maxEl: 1, tabSize: 200, initMargin:400 };
  const battProps = { maxEl: 1, tabSize: 240, initMargin:400 };

  const getCvHeight = (canvasProps, numElements) => {
    if (numElements<=canvasProps.maxEl) return CANVAS_DEFAULT_HEIGHT;
    const extElements = numElements-canvasProps.maxEl;
    
    return CANVAS_DEFAULT_HEIGHT-canvasProps.initMargin+canvasProps.tabSize*(extElements)+CANVAS_MIN_BOT_BORDER;
  }
  const loads_H1=getCvHeight(loadProps1, nodeCounters.LOADS_L);
  const loads_H2=getCvHeight(loadProps2, nodeCounters.LOADS_R);

  return {
    MAIN_GROUP: getCvHeight(mainProps, nodeCounters.MAIN_GROUP),//CANVAS_DEFAULT_HEIGHT,
    DER_AC: getCvHeight(acProps, nodeCounters.DER_AC),
    DER_DC: getCvHeight(dcProps, nodeCounters.DER_DC),
    LOADS: Math.max(loads_H1,loads_H2),
    BUS: getCvHeight(busProps, nodeCounters.BUS),
    BATT: getCvHeight(battProps, nodeCounters.BATT),
    BATT_String: getCvHeight(battProps, nodeCounters.BATT_String),
  }
}

/**
 * Initializes graphic elements for a screen nodes map containing EnfyoLayoutNodes array
 * @param {Map<string, EnfyoLayoutNode[]>} screenNodesMap 
 * @returns {{ MAIN_GROUP: CanvasProps, DER_AC: CanvasProps, DER_DC: CanvasProps, LOADS: CanvasProps}}
 */
let battery_num = 0
export const attachGraphics = async (screenNodesMap) => {
  resetNodeCounters();
  const loader =  new PIXI.Loader();
  loadNodeResources(loader)

  await new Promise((resolve, reject) => {
    try{
      loader.load(()=>{resolve('ok')})
    }catch(err){
      reject(err)
    }
    
  });

  for(const [screenName, screenNodes] of screenNodesMap){

    nodeCounters.MAIN_GROUP=0;
    nodeCounters.BUS=0;
    nodeCounters.BUS_NODES=0;
    bus_corner_x = 2700
    // Common Nodes
    
    const screenNodes_fixed = screenNodes.filter(n=>['GRID_Generic','ENFYO_controller','Gateway','METER_Generic'].includes(n.type))
    for(const node of screenNodes_fixed) setNodeGraphic (node,screenName,loader)
    
    // nodes connected to bus 1
    let grid_bus = screenNodes.find(n=>['GRID_Generic'].includes(n.type)).bus


    const screenNodes_loads = screenNodes.filter(n=>['LOAD_Generic'].includes(n.type))
    for(const node of screenNodes_loads) setNodeGraphic (node,screenName,loader)

    const screenNodes_loads_ev = screenNodes.filter(n=>['LOAD_Dispatched'].includes(n.type))
    for(const node of screenNodes_loads_ev) setNodeGraphic (node,screenName,loader)
    
    const screenNodes_loads_hs = screenNodes.filter(n=>['LOAD_Hydroscrew'].includes(n.type))
    for(const node of screenNodes_loads_hs) setNodeGraphic (node,screenName,loader)

    const screenNodes_racks = screenNodes.filter(n=>['DC_Storage_Rack','DC_Storage_Rack_Led'].includes(n.type))
    for(const node of screenNodes_racks) setNodeGraphic (node,screenName,loader) 
    
    const screenNodes_batt = screenNodes.filter(n=>['DER_DC_Storage'].includes(n.type))
    battery_num = screenNodes_batt.length
    for(const node of screenNodes_batt) setNodeGraphic (node,screenName,loader)

    const screenNodes_pcs = screenNodes.filter(n=>['DER_Inverter'].includes(n.type))
    for(const node of screenNodes_pcs) setNodeGraphic (node,screenName,loader) 

    const screenNodes_cgm_pcs = screenNodes.filter(n=>['CGM_PCS'].includes(n.type))
    for(const node of screenNodes_cgm_pcs) setNodeGraphic (node,screenName,loader)

    const screenNodes_bus0 = screenNodes.find(n=>['BUS_Generic'].includes(n.type) && n.bus == grid_bus)
    setNodeGraphic (screenNodes_bus0,screenName,loader)

    // nodes connected to bus 2
    nodeCounters.BUS_NODES=nodeCounters.MAIN_GROUP;

    const screenNodes_cbt = screenNodes.filter(n=>['CBT'].includes(n.type))
    for(const node of screenNodes_cbt) setNodeGraphic (node,screenName,loader)
    
    const screenNodes_cgm = screenNodes.filter(n=>['CGM'].includes(n.type))
    for(const node of screenNodes_cgm) setNodeGraphic (node,screenName,loader)

    const screenNodes_logger = screenNodes.filter(n=>['PV_Logger'].includes(n.type))
    nodeCounters.MAIN_GROUP+=screenNodes_logger.length;
    if(nodeCounters.MAIN_GROUP_RACKS<3) nodeCounters.MAIN_GROUP+=1
    
    const screenNodes_pv_string = screenNodes.filter(n=>['DC_Generation_Group'].includes(n.type))
    for(const node of screenNodes_pv_string) setNodeGraphic (node,screenName,loader)

    const screenNodes_pv_inverters = screenNodes.filter(n=>['DER_Inverter_PV','DER_Inverter_Contactor'].includes(n.type))
    for(const node of screenNodes_pv_inverters) setNodeGraphic (node,screenName,loader) 

    for(const node of screenNodes_logger) setNodeGraphic (node,screenName,loader) 

    const screenNodes_bus = screenNodes.filter(n=>['BUS_Generic'].includes(n.type) && n.bus != grid_bus)
    for(const node of screenNodes_bus) setNodeGraphic (node,screenName,loader)
    
  }

  const canvasProps = {};
  const heights = getCanvasHeights();
  for(const [screenName, screenNodes] of screenNodesMap){
    canvasProps[screenName] = {
      nodeCounters: nodeCounters[screenName],
      canvasHeight: heights[screenName],
      screenNodes
    };
    
  }

  return canvasProps;
}

function setNodeGraphic (node,screenName,loader) {
  node.graphics = buildNodeGraphicsMap(screenName, node.type, node.subtype,loader.resources);

  updateNodeTitle(node.graphics, node.caption);
  updateNodeDescription(node.graphics, node.description);
  setKpiVisibility(node.graphics, node.showKpiWindow);
}
/**
 * register signals in a map
 * @param {Map<string, EnfyoGraphicNode[]>} screenNodesMap - map of screens with a list of graphic nodes
 * @param {EnfyoSignal[]} signalList 
 */
export const registerSignals = (screenNodesMap, signalList) => {
  if(!signalList.length) throw new Error('Cannot register signals on graphic controls invalid signalList');
  for(const [, screenNodes] of screenNodesMap){
    for(const node of screenNodes){
      const kpiWindowCtr = node.graphics?.get?.('kpiWindow');
      if(!kpiWindowCtr) continue;
    
      const nodeSignals = [];
      const sig1 = signalList.find(sig => sig.signalId==node.signal1_id)
      const sig2 = signalList.find(sig => sig.signalId==node.signal2_id)
      const sig3 = signalList.find(sig => sig.signalId==node.signal3_id)
      if (sig1) nodeSignals.push(sig1); 
      if (sig2) nodeSignals.push(sig2); 
      if (sig3) nodeSignals.push(sig3); 
      kpiWindowCtr.setKpiSignals(nodeSignals);
    }
  }
}

/**
 * updates graphs with values from a signal sample array
 * @param {Map<string, EnfyoGraphicNode[]>} screenNodesMap - map of screens with a list of graphic nodes
 * @param {EnfyoSignalSample[]} signalSamples - list of samples to update in graphs
 */
export const updateKpiSigVals = (screenNodesMap, signalSamples) => {
  if(!signalSamples.length) return ; //silently exit if no samples found
  for(const [, screenNodes] of screenNodesMap){
    for(const node of screenNodes){
      const kpiWindowCtr = node.graphics?.get?.('kpiWindow');
      if(kpiWindowCtr) // silently exit if no kpi window in node
      kpiWindowCtr.updateKpiValues(signalSamples);
    }
  }
}

// popups
export const registerGraphSignals = async (screenNodesMap, signalList,grapViewSignals) => {
  try{
    
    const influxDataService = new RawDataService(`influx`); 

    const signalGraphMap = new Map();
    const signalGraphArray = new Array();
    if(!signalList.length) throw new Error('Cannot register signals on graphic controls invalid signalList');
    const initTime=new Date().setHours(0,0,0,0);
    const endTime=new Date().getTime();

    for(var sig of grapViewSignals){
      signalGraphMap.set(sig.signalId,{
        name: sig.label,
        namesig: sig.name, 
        node: sig.Node?.id,
        units: sig.units|| '',
        assetName: sig.assetName,
        started:false});
    }
   
    for(const [, screenNodes] of screenNodesMap){
      for(const node of screenNodes){
        
        const sig1 = signalList.find(sig => sig.Node?.id==node.id  && sig.signalId==node.signal1_id)
        const sig2 = signalList.find(sig => sig.Node?.id==node.id  && sig.signalId==node.signal2_id)
        const sig3 = signalList.find(sig => sig.Node?.id==node.id  && sig.signalId==node.signal3_id)
        
        if (sig1) signalGraphMap.set(sig1.signalId,{
          name: sig1.label, 
          namesig: sig1.name,
          node:sig1.Node.id,
          units:sig1.units|| '',
          assetName:sig1.assetName,
          started:false});

        if (sig2) signalGraphMap.set(sig2.signalId,{
          name: sig2.label, 
          namesig: sig2.name,
          node:sig2.Node.id,
          units:sig2.units|| '',
          assetName:sig2.assetName,
          started:false});

        if (sig3) signalGraphMap.set(sig3.signalId,{
          name: sig3.label, 
          namesig: sig3.name,
          node:sig3.Node.id,
          units:sig3.units|| '',
          assetName:sig3.assetName,
          started:false});
      }
          
    }
  
    for(const [key, value] of signalGraphMap.entries()){
      const dataInflux = await influxDataService.getByKey(value.assetName+'/signalStorage/'+value.namesig+'?timeInterval=10m&dateStart='+initTime+'&dateEnd='+endTime )

      if(dataInflux.length==0){
          signalGraphArray.push({timestamp: new Date().getTime(), ['val'+key] : null, signal: key})
        }else{
          for(const data of dataInflux){
            
            signalGraphArray.push({timestamp: new Date(data.time).getTime(), ['val'+key] : data[value.namesig], signal: key})
          }
        }
    }
    
    let signalGraphDS = {value: null, data: null}
    signalGraphDS.data=signalGraphArray;

    signalGraphDS.value= Array.from(signalGraphMap, function (entry) {
      let gtype, scale, Wunit, stats=null;
      if (entry[1].units!=null && entry[1].units!=''  && entry[1].units.includes('W')){
        gtype='area';
        Wunit='kW';
        scale=0.001;
        stats={integralFN:(array)=>{
          var sum=0;
          for(var i in array){
            sum+=parseFloat(array[i]);
          }
          return (sum/(array.length)).toFixed(2);
        }}
      }else{  
        gtype='line';
        Wunit=entry[1].units;
        scale=1;
        stats={};
      }
      return { key: entry[0], 
        name: entry[1].name, 
        node: entry[1].node,
        assetName: entry[1].assetName,
        units: Wunit, 
        GraphScale:scale , 
        GraphType:gtype,
        started: entry[1].started,
        stats:stats
      };
    });

    return signalGraphDS;
  }catch(err){console.log('error: '+ err.message)}
}


// Animations 
const animationNodesMap = new Map();
export const registerAnimationSignals = (screenNodesMap, signalList) =>{
  if(!signalList.length) throw new Error('Cannot register signals on graphic controls invalid signalList');
  
  for(const [, screenNodes] of screenNodesMap){
    
    for(const node of screenNodes){
     
      if(node.graphics?.get?.('contactorAnimation')) {
        const signalAnimation = signalList.filter(sig =>sig.Asset?.id==node.asset_id && sig.name=="Work state");
        for(let sigAn of signalAnimation){
            animationNodesMap.set('contactorAnimation_'+node.id,{
              kpiWindowCtr:'contactorAnimation',
              signals:[sigAn],
              node:node.id,
              started:false});
  
        }
      }

      if(node.graphics?.get?.('StatusLed')) {
        const signalAnimation = signalList.filter(sig =>sig.Asset?.id==node.asset_id && sig.name=="Work state");
        for(let sigAn of signalAnimation){
            animationNodesMap.set('statusLedAnimation_'+node.id,{
              kpiWindowCtr:'StatusLed',
              signals:[sigAn],
              node:node.id,
              started:false});
  
        }
      }
      if(node.graphics?.get?.('contactor_CBT')) {
        const signalAnimation = signalList.filter(sig =>sig.Asset?.id==node.asset_id && sig.name=="Work state");
        for(let sigAn of signalAnimation){
            animationNodesMap.set('contactor_CBTAnimation_'+node.id,{
              kpiWindowCtr:'contactor_CBT',
              signals:[sigAn],
              node:node.id,
              started:false});
        }
      }

      if(node.graphics?.get?.('alarm')) {
        const signalAnimation = signalList.filter(sig =>sig.Asset?.id==node.asset_id && sig.name=="Alarm state");
        for(let sigAn of signalAnimation){
            animationNodesMap.set('alarmAnimation_'+node.id,{
              kpiWindowCtr:'alarm',
              signals:[sigAn],
              node:node.id,
              started:false});
        }
      }
      
    }
  } 
}

export const updateAnimationsSigVals = (screenNodesMap, signalSamples) =>{
 
  if(!signalSamples.length) return ; //silently exit if no samples found
  
  for(const _animation of Array.from(animationNodesMap.keys())){
    const animation=animationNodesMap.get(_animation)
    const animationSigsVals = [];

    signalSamples.forEach((sig)=>{
      if(animation.signals.find(sa=>sa.signalId==sig.signalId))
        animationSigsVals.push(sig.currentValue)
    })
    
    for(const [, screenNodes] of screenNodesMap){
      const node=screenNodes.find(node => node.id==animation.node);
      if(node){       
          const animationCtr = node.graphics?.get?.(animation.kpiWindowCtr);
          if(animationCtr){ // silently exit if no kpi window in node
              animationCtr.animation(animationSigsVals,animationCtr)}
            //animationCtr.animation(animationSigsVals,animationCtr)}
      }      
    }
  }
  

}


/**
 * organizes a node array into a map of screens - list of nodes
 * @param {EnfyoLayoutNode[]} graphNodes - table of nodes, must include node family under NodeType property
 * @returns {Map<string, EnfyoGraphicNode[]>}
 */
export const buildGraphsMap = (graphNodes) => {
  const screenNodesMap = new Map();
  //build basic nodes for screens
  for(const node of graphNodes){
    if(!node.enabled) continue; // skip if node is disabled
    if(!screenNodesMap.has(node.NodeType.screen_id)) screenNodesMap.set(node.NodeType.screen_id, []);
       // add nodes to screen bus

    const screenNodes = screenNodesMap.get(node.NodeType.screen_id)
    screenNodes.push({
      id: node.id,
      caption: node.caption,
      type: node.NodeType.type,
      subtype: node.NodeType.subtype,
      description: node.description,
      showKpiWindow: node.showKpiWindow,
      asset_id: node.asset_id,
      signal1_id: node.signal1_id,
      signal2_id: node.signal2_id,
      signal3_id: node.signal3_id,
      bus: node.enfyoBuses_uuid
      //TODO: add properties for variables and commands?
    })
  }

  return screenNodesMap;
}

/**
 * change description for a node graphics map
 * @param {Map<string, PIXI.Graphics>} nodeGraphicsMap - node pixi graphics map 
 * @param {string} titleText - text to change in description
 * @returns {void}
 */
const updateNodeDescription = (nodeGraphicsMap, descriptText='') => {
  if(!nodeGraphicsMap) return ;
  const textObj = nodeGraphicsMap.get('description');
  if(!textObj) return ;
  textObj.text = descriptText||'';
}

/**
 * change title for a node graphics map
 * @param {Map<string, PIXI.Graphics>} nodeGraphicsMap - node pixi graphics map 
 * @param {string} titleText - text to change in title
 * @returns {void}
 */
 const updateNodeTitle = (nodeGraphicsMap, titleText) => {
  if(!nodeGraphicsMap) return ;
  const titleObj = nodeGraphicsMap.get('title');
  if (titleObj) titleObj.text = titleText;
}

/**
 * change kpi window visibility for a node graphics map 
 * @param {Map<string, PIXI.Graphics>} nodeGraphicsMap - node pixi graphics map 
 * @param {string} titleText - text to change in title
 * @returns {void}
 */
const setKpiVisibility = (nodeGraphicsMap, isVisible=false) => {
  const window = nodeGraphicsMap?.get('kpiWindow');
  if(!window) return ;
  window.visible = isVisible;
}





export const animationPoint = (app,graph,charge,offset)=>{

  let dir,x,y,x_end,y_end,x_ini,y_ini;
  let points=graph.points;
  if (charge){
    for(let i = 0; i < Math.floor(points.length/2); i++) {
      let temporal =points[i];
      points[i] = points[points.length - 1 - i];
      points[points.length - 1 - i] = temporal;
    }
  }
   

  //const num_points = graph.points.length;
  const aux_x = points[1][0]-points[0][0];
  const aux_y = points[1][1]-points[0][1];
  const step_x = parseInt(aux_x/Math.sqrt(Math.pow(aux_x,2)+Math.pow(aux_y,2)));
  const step_y = parseInt(aux_y/Math.sqrt(Math.pow(aux_x,2)+Math.pow(aux_y,2)));

  x = offset*step_x;
  y = offset*step_y;

  x_ini=0;
  y_ini=0;
  x_end = points[1][0]-points[0][0];
  y_end = points[1][1]-points[0][1];
  dir=1;
  

  app.ticker.add(()=>{
    if (x*dir >= x_end*dir & y*dir >= y_end*dir) {
      x = x_ini;
      y = y_ini;
    }
    graph.x=x;
    graph.y=y;
    x += 2*step_x*dir;
    y += 2*step_y*dir;

  });


}




/**
 * builds and returns a map of graphics that build graphic node and energy line link
 * returns undefined if no graphic has been found for the screen-nodeType-Subtype combination
 * @param {string} screenName - screen name to find node (MAIN_GROUP, DER_DC, DER_AC, LOADS)
 * @param {string} nodeType - node type (DER_DC_Generator, DER_DC_Storage....)
 * @param {string} nodeSubType - node subtype - depends of type (PV, Wind, EV, ...)
 * @returns {Map<string, PIXI.Graphics>}
 */

const loadNodeResources = (loader)=>{
  // MAIN
  
 
    if(!('dy11' in loader.resources))
      loader.add('dy11', require('../assets/objects/dy11.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))

    if(!('grid_w' in loader.resources))
      loader.add('grid_w', require('../assets/objects/grid_w.png'))
    if(!('dy11' in loader.resources))
      loader.add('dy11', require('../assets/objects/dy11.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))

    if(!('meter_w' in loader.resources))
      loader.add('meter_w', require('../assets/objects/meter_w.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))

    if(!('solarpanel_w' in loader.resources))
      loader.add('solarpanel_w', require('../assets/objects/solarpanel_w.png'))
    if(!('link' in loader.resources))

    if(!('battery_w' in loader.resources))
      loader.add('battery_w', require('../assets/objects/battery_w.png'))

    if(!('storage' in loader.resources))
      loader.add('storage', require('../assets/objects/storage.png'))
    if(!('link' in loader.resources))
      loader.add('link', require('../assets/objects/link.png'))

    if(!('dc_to_ac_w' in loader.resources))
      loader.add('dc_to_ac_w', require('../assets/objects/dc_to_ac_w.png'))
    if(!('link' in loader.resources))
      loader.add('link', require('../assets/objects/link.png'))
    if(!('dy11' in loader.resources))
      loader.add('dy11', require('../assets/objects/dy11.png'))
    if(!('alert' in loader.resources))
      loader.add('alert',require( '../assets/objects/alert.svg'))

    if(!('dc_to_ac_w' in loader.resources))
      loader.add('dc_to_ac_w', require('../assets/objects/dc_to_ac_w.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))
    if(!('link_ok' in loader.resources))
      loader.add('link_ok',require( '../assets/objects/link_ok.png'))
  
    if(!('meter_w' in loader.resources))
      loader.add('meter_w',require( '../assets/objects/meter_w.png'))
 
    if(!('solarpanel_w' in loader.resources))
      loader.add('solarpanel_w',require( '../assets/objects/solarpanel_w.png'))
    if(!('dc_to_ac_w' in loader.resources))
      loader.add('dc_to_ac_w',require( '../assets/objects/dc_to_ac_w.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))

    if(!('battery_w' in loader.resources))
      loader.add('battery_w',require( '../assets/objects/battery_w.png'))
    if(!('dc_to_ac_w' in loader.resources))
      loader.add('dc_to_ac_w',require( '../assets/objects/dc_to_ac_w.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))

    if(!('factory_w' in loader.resources))
      loader.add('factory_w',require( '../assets/objects/factory_w.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))
 
    if(!('load_ev_w' in loader.resources))
      loader.add('load_ev_w',require( '../assets/objects/load_ev_w.png'))
    if(!('link' in loader.resources))
      loader.add('link',require( '../assets/objects/link.png'))

    if(!('enfyo_w' in loader.resources))
      loader.add('enfyo_w', require('../assets/objects/enfyo_w.png'))

    if(!('hidroscrew' in loader.resources))
      loader.add('hidroscrew', require('../assets/objects/hidroscrew.png'))
}
let bus_corner_x = 2800;
const buildNodeGraphicsMap = (screenName_, nodeType, nodeSubType,resources) => {

  const screenName = screenName_ || '';
  // MAIN
  const graphMap = new Map();
  const init_pos_x = 200
  const init_pos_y = 300;
  
  const margin_node_groups_y = 50;
  const width_node_space = 800;
  const height_node_space = 320;
  // Contactor variables
  const cont_size_y = 30;
  const cont_size_x = 40;
  const cont_dist_bus = 100;
  const cont_margin_box = 16;

  if(nodeType=='BUS_Generic'){
    
    const corner_x = bus_corner_x;
    let corner_y = init_pos_y - BUS_WIDTH;//
    let groups_racks = 0
    let groups_aux = nodeCounters.MAIN_GROUP_GRID + nodeCounters.MAIN_GROUP_LOADS
    let racks_aux = nodeCounters.MAIN_GROUP_RACKS

    if(nodeCounters.MAIN_GROUP_RACKS>=1) {
      groups_racks = (racks_aux/battery_num)
    } else{
      groups_racks = 1
    }

    let height = (height_node_space)*(groups_aux-1) + margin_node_groups_y
      + groups_racks*height_node_space*battery_num-(groups_racks-1)/2*height_node_space + margin_node_groups_y+ BUS_WIDTH*2//-(pv_inv_aux)*(height_node_space);

    if(nodeCounters.BUS>=1){
      corner_y = corner_y+height/2;
     
      height = (height_node_space)*(nodeCounters.MAIN_GROUP-1)+ (groups_aux+2)*margin_node_groups_y + BUS_WIDTH*2 - corner_y;

      graphMap.set('line', getLinkLine([  [bus_corner_x-500+parseInt(BUS_WIDTH/2),corner_y+BUS_WIDTH],[bus_corner_x+parseInt(BUS_WIDTH/2),corner_y+BUS_WIDTH]]));  
      graphMap.set('node', getNodeSprite(resources['link'], bus_corner_x-14+parseInt(BUS_WIDTH/2),corner_y-14+BUS_WIDTH, 30, 30,false));
      graphMap.set('node2', getNodeSprite(resources['link'], bus_corner_x-500-14+parseInt(BUS_WIDTH/2),corner_y-14+BUS_WIDTH, 30, 30,false));
      graphMap.set('dy11', getNodeSprite(resources['dy11'], corner_x-250-NODE_AUX_SIZE/2+BUS_WIDTH/2, corner_y-parseInt(NODE_AUX_SIZE/2)+BUS_WIDTH, NODE_AUX_SIZE,NODE_AUX_SIZE),false); //+230
      graphMap.set('dy11Bk', getNodeBackground(corner_x-250-NODE_AUX_SIZE/2+BUS_WIDTH/2, corner_y-parseInt(NODE_AUX_SIZE/2)+BUS_WIDTH, NODE_AUX_SIZE));  
      
    }
    graphMap.set('lineBus', getLinkLineBus(corner_x,corner_y,height,BUS_WIDTH,'',1,false)); 
    graphMap.set('title', getNodeTitle(nodeType, corner_x-30, corner_y-BUS_WIDTH));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+140, 80+30));


    nodeCounters.BUS+=1;
    bus_corner_x =  bus_corner_x+500
  }

  if(nodeType=='CBT'){
  
    let corner_y = init_pos_y - BUS_WIDTH;//
    let groups_racks = 0
    let groups_aux = nodeCounters.MAIN_GROUP_GRID + nodeCounters.MAIN_GROUP_LOADS
    let racks_aux = nodeCounters.MAIN_GROUP_RACKS

    if(nodeCounters.MAIN_GROUP_RACKS>=1) {
      groups_racks = (racks_aux/battery_num)
    } else{
      groups_racks = 1
    }

    let height = (height_node_space)*(groups_aux-1) + margin_node_groups_y
    + groups_racks*height_node_space*battery_num-(groups_racks-1)/2*height_node_space + margin_node_groups_y+ BUS_WIDTH*2//-(pv_inv_aux)*(height_node_space);

    corner_y = corner_y+height/2;
   
    const center_y = corner_y+parseInt(NODE_AUX_SIZE/2)-10;
    graphMap.set('contactor_CBT', getCBT(bus_corner_x-cont_dist_bus-cont_margin_box,center_y-cont_size_y-cont_margin_box,true))
    graphMap.set('title_CBT', getNodeTitle('CBT', bus_corner_x-cont_dist_bus-cont_margin_box+35, center_y-cont_size_y-cont_margin_box-45));
    graphMap.set('alarm', getAlarm(bus_corner_x-cont_dist_bus-cont_margin_box+8,center_y-150),false); 

  }

  if(nodeType=='CGM'){
  
    let corner_y = init_pos_y - BUS_WIDTH;//
    let groups_racks = 0
    let groups_aux = nodeCounters.MAIN_GROUP_GRID + nodeCounters.MAIN_GROUP_LOADS
    let racks_aux = nodeCounters.MAIN_GROUP_RACKS

    if(nodeCounters.MAIN_GROUP_RACKS>=1) {
      groups_racks = (racks_aux/battery_num)
    } else{
      groups_racks = 1
    }

    let height = (height_node_space)*(groups_aux-1) + margin_node_groups_y
      + groups_racks*height_node_space*battery_num-(groups_racks-1)/2*height_node_space + margin_node_groups_y+ BUS_WIDTH*2//-(pv_inv_aux)*(height_node_space);

    corner_y = corner_y+height/2;
  
    const center_y = corner_y+parseInt(NODE_AUX_SIZE/2)-10;

    graphMap.set('contactor_CGM', getCGM(bus_corner_x-500+cont_dist_bus-cont_margin_box+BUS_WIDTH/4,center_y-cont_size_y-cont_margin_box,true))
    graphMap.set('title_CGM', getNodeTitle('CGM', bus_corner_x-500+cont_dist_bus-cont_margin_box+BUS_WIDTH/4+35, center_y-cont_size_y-cont_margin_box-45));
    graphMap.set('alarm', getAlarm(bus_corner_x-500+cont_dist_bus-cont_margin_box+BUS_WIDTH/4+8,center_y-150),false); 
  }

  if(nodeType=='CGM_PCS'){
  
    let corner_y;
    
    let size_group_racks,step_groups_racks
    if(nodeCounters.MAIN_GROUP_RACKS>=1){      
      size_group_racks = nodeCounters.MAIN_GROUP_RACKS/battery_num;
      step_groups_racks = (size_group_racks-1)/2*height_node_space
      corner_y = init_pos_y + margin_node_groups_y*2 + 
        (nodeCounters.MAIN_GROUP-nodeCounters.MAIN_GROUP_RACKS + 
        nodeCounters.MAIN_GROUP_CGM_PCS)*height_node_space-parseInt(NODE_SMALL_SIZE/2)
      + step_groups_racks*(1+2*nodeCounters.MAIN_GROUP_CGM_PCS);
    }
    else {
      let step_groups_racks = 0
      corner_y = init_pos_y + margin_node_groups_y*2 + (nodeCounters.MAIN_GROUP-1)*height_node_space+ step_groups_racks*nodeCounters.MAIN_GROUP_CGM_PCS-parseInt(NODE_SMALL_SIZE/2);
    }
  
    nodeCounters.MAIN_GROUP_CGM_PCS+=1

    const corner_x = init_pos_x+width_node_space*2-parseInt(NODE_SMALL_SIZE/2);
    const center_y = corner_y+parseInt(NODE_SMALL_SIZE/2);
    const center_x = corner_x + parseInt(NODE_SMALL_SIZE/2);
    
    graphMap.set('contactor_CGM', getCGM(center_x+800-cont_margin_box,center_y-cont_size_y-cont_margin_box,true)) 
    graphMap.set('title_CGM', getNodeTitle('CGM', center_x+800-cont_margin_box+35, center_y-cont_size_y-cont_margin_box-45));
    graphMap.set('alarm', getAlarm(center_x+800-cont_margin_box+8,center_y-150),false); 
  }


  if(nodeType=='GRID_Generic'){
    const corner_x = init_pos_x+width_node_space-parseInt(NODE_MAIN_SIZE/2);
    const corner_y = init_pos_y-parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x+parseInt(NODE_MAIN_SIZE/2);
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);
    graphMap.set('mainGraph', getNodeSprite(resources['grid_w'], corner_x, corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));  
    graphMap.set('line', getLinkLine([ [center_x,center_y], [bus_corner_x+parseInt(BUS_WIDTH/2),center_y]]));  
    graphMap.set('title', getNodeTitle(nodeType, center_x, corner_y-60));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 
 
    graphMap.set('kpiWindow', new KpiWindow(center_x+120,center_y-200));
    graphMap.set('description', getNodeDescription('', center_x+120, center_y+40));
    nodeCounters.MAIN_GROUP_GRID+=1;
  }

  if( nodeType=='METER_Generic'){
    const corner_x = init_pos_x+width_node_space*2-parseInt(NODE_AUX_SIZE/2);
    const corner_y = init_pos_y-parseInt(NODE_AUX_SIZE/2);
    const center_x = corner_x+parseInt(NODE_AUX_SIZE/2);
    const center_y = corner_y+parseInt(NODE_AUX_SIZE/2);

    graphMap.set('mainGraph', getNodeSprite(resources['meter_w'], corner_x, corner_y, NODE_AUX_SIZE, NODE_AUX_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_AUX_SIZE));  
    graphMap.set('alarm', getAlarm(corner_x-60,corner_y-15)); 

    graphMap.set('title', getNodeTitle(nodeType,  center_x , corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+230-20,corner_y-90-40));
    graphMap.set('description', getNodeDescription('', corner_x+280, 360));

    graphMap.set('line', getLinkLine([ [center_x,center_y], [bus_corner_x+parseInt(BUS_WIDTH/2),center_y]]));
    graphMap.set('node', getNodeSprite(resources['link'], bus_corner_x-14+parseInt(BUS_WIDTH/2), center_y-14, 30, 30,false));

    nodeCounters.MAIN_GROUP+=1;
  

  }

  if(nodeType=='LOAD_Generic'){
    const corner_y = init_pos_y + margin_node_groups_y +(nodeCounters.MAIN_GROUP)*height_node_space-parseInt(NODE_MAIN_SIZE/2);
    const corner_x = init_pos_x + width_node_space -parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x+parseInt(NODE_MAIN_SIZE/2);
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);

    nodeCounters.MAIN_GROUP+=1;
    nodeCounters.MAIN_GROUP_LOADS+=1;
    const corner_x_bus=bus_corner_x;
    //const corner_y_bus=230;
    
    graphMap.set('mainGraph', getNodeSprite(resources['factory_w'], corner_x, corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 

    graphMap.set('node', getNodeSprite(resources['link'], corner_x_bus+14,center_y-14, 30, 30));
    graphMap.set('line', getLinkLine([ [corner_x+170,center_y], [corner_x_bus+14,center_y] ]));
  

    graphMap.set('title', getNodeTitle(nodeType,center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+260, corner_y-60-40));
    graphMap.set('description', getNodeDescription('', corner_x+300, corner_y));
    
  }

  if( nodeType=='DC_Storage_Rack'){
    let corner_y;
    if(screenName=='MAIN_GROUP'){
      corner_y = init_pos_y + margin_node_groups_y*2 + nodeCounters.MAIN_GROUP*height_node_space-parseInt(NODE_MAIN_SIZE/2);
      nodeCounters.MAIN_GROUP+=1;
      nodeCounters.MAIN_GROUP_RACKS+=1;
    }else if(screenName=='LOADS'){
      corner_y = init_pos_y + margin_node_groups_y*2 + nodeCounters.LOADS_L*height_node_space-parseInt(NODE_MAIN_SIZE/2);
      nodeCounters.LOADS_L+=1;
    }
    const corner_x = init_pos_x-parseInt(NODE_MAIN_SIZE/2) ; 
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x +parseInt(NODE_MAIN_SIZE/2);


    graphMap.set('mainGraph', getNodeSprite(resources['battery_w'], corner_x,corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 

    graphMap.set('line', getLinkLine([ [center_x,center_y], [860,center_y]]));
    graphMap.set('title', getNodeTitle(nodeType, center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+260, corner_y-60-40));
    graphMap.set('description', getNodeDescription('', 400, corner_y+130, 200));

  }

  if( nodeType=='DC_Storage_Rack_Led'){
    let corner_y;
    if(screenName=='MAIN_GROUP'){
      corner_y = init_pos_y + margin_node_groups_y*2 + nodeCounters.MAIN_GROUP*height_node_space-parseInt(NODE_MAIN_SIZE/2);
      nodeCounters.MAIN_GROUP+=1;
      nodeCounters.MAIN_GROUP_RACKS+=1;
    }else if(screenName=='LOADS'){
      corner_y = init_pos_y + margin_node_groups_y*2 + nodeCounters.LOADS_L*height_node_space-parseInt(NODE_MAIN_SIZE/2);
      nodeCounters.LOADS_L+=1;
    }
    const corner_x = init_pos_x-parseInt(NODE_MAIN_SIZE/2) ; 
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x +parseInt(NODE_MAIN_SIZE/2);


    graphMap.set('mainGraph', getNodeSprite(resources['battery_w'], corner_x,corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-60,corner_y)); 

    graphMap.set('line', getLinkLine([ [center_x,center_y], [860,center_y]]));
    graphMap.set('title', getNodeTitle(nodeType, center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+260, corner_y-60-40));
    graphMap.set('description', getNodeDescription('', 400, corner_y+130, 200));

    graphMap.set('StatusLed', getStatusLed(corner_x+10,corner_y))
  }

  
  if(nodeType=='DER_DC_Storage'){
    let corner_y;
    let size_group_racks,step_groups_racks
    if(nodeCounters.MAIN_GROUP_RACKS==0) nodeCounters.MAIN_GROUP+=1
    if(nodeCounters.MAIN_GROUP_RACKS>=1){      
      size_group_racks = nodeCounters.MAIN_GROUP_RACKS/battery_num;
      step_groups_racks = (size_group_racks-1)/2*height_node_space
      corner_y = init_pos_y + margin_node_groups_y*2 + (nodeCounters.MAIN_GROUP-nodeCounters.MAIN_GROUP_RACKS + nodeCounters.MAIN_GROUP_BATTS)*height_node_space-parseInt(NODE_MAIN_SIZE/2)
      + step_groups_racks*(1+2*nodeCounters.MAIN_GROUP_BATTS);
    }
    else {
      let step_groups_racks = 0
      corner_y = init_pos_y + margin_node_groups_y*2 + (nodeCounters.MAIN_GROUP-1)*height_node_space+ step_groups_racks*nodeCounters.MAIN_GROUP_BATTS-parseInt(NODE_MAIN_SIZE/2);
    }
   
    nodeCounters.MAIN_GROUP_BATTS+=1

    const corner_x = init_pos_x+width_node_space-parseInt(NODE_MAIN_SIZE/2);
    const center_y = corner_y + parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x + parseInt(NODE_MAIN_SIZE/2);
    graphMap.set('mainGraph', getNodeSprite(resources['storage'], corner_x,corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-40,corner_y-15)); 

    graphMap.set('title', getNodeTitle(nodeType, center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+260, corner_y-60-40));
    graphMap.set('description', getNodeDescription('', 400, corner_y+130, 200));


    graphMap.set('line', getLinkLine([ [center_x,center_y], [1140,center_y],[bus_corner_x + parseInt(BUS_WIDTH/2),center_y]]));

    if (nodeCounters.MAIN_GROUP_RACKS>=1){
      const center_y_sup = center_y-step_groups_racks;
      const center_y_inf = center_y+step_groups_racks;
      graphMap.set('lineh', getLinkLine([ [860,center_y],[center_x,center_y] ]));
      graphMap.set('linev', getLinkLine([ [860,center_y_sup],[860,center_y_inf] ]));
    }
    
    graphMap.set('node', getNodeSprite(resources['link'], bus_corner_x-14+parseInt(BUS_WIDTH/2), center_y-14, 30, 30,false)); 
    
  }

  if( nodeType=='DER_Inverter'){
    let corner_y;
    
    let size_group_racks,step_groups_racks
    if(nodeCounters.MAIN_GROUP_RACKS>=1){      
      size_group_racks = nodeCounters.MAIN_GROUP_RACKS/battery_num;
      step_groups_racks = (size_group_racks-1)/2*height_node_space
      corner_y = init_pos_y + margin_node_groups_y*2 + 
        (nodeCounters.MAIN_GROUP-nodeCounters.MAIN_GROUP_RACKS + 
          nodeCounters.MAIN_GROUP_PCS)*height_node_space-parseInt(NODE_SMALL_SIZE/2)
      + step_groups_racks*(1+2*nodeCounters.MAIN_GROUP_PCS);
    }
    else {
      let step_groups_racks = 0
      corner_y = init_pos_y + margin_node_groups_y*2 + (nodeCounters.MAIN_GROUP-1)*height_node_space+ step_groups_racks*nodeCounters.MAIN_GROUP_PCS-parseInt(NODE_SMALL_SIZE/2);
    }

    nodeCounters.MAIN_GROUP_PCS+=1

    const corner_x = init_pos_x+width_node_space*2-parseInt(NODE_SMALL_SIZE/2);
    const center_y = corner_y+parseInt(NODE_SMALL_SIZE/2);
    const center_x = corner_x + parseInt(NODE_SMALL_SIZE/2);

    graphMap.set('mainGraph', getNodeSprite(resources['dc_to_ac_w'], corner_x,corner_y, NODE_SMALL_SIZE, NODE_SMALL_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_SMALL_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 

    graphMap.set('node', getNodeSprite(resources['link'], bus_corner_x-14+parseInt(BUS_WIDTH/2), center_y-14, 30, 30,false)); 
    graphMap.set('line', getLinkLine([ [center_x,center_y], [bus_corner_x+parseInt(BUS_WIDTH/2),center_y]])); 
    graphMap.set('dy11', getNodeSprite(resources['dy11'], center_x+600, center_y-NODE_AUX_SIZE/2, NODE_AUX_SIZE,NODE_AUX_SIZE),false); //+230
    graphMap.set('dy11Bk', getNodeBackground(center_x+600, center_y-NODE_AUX_SIZE/2, NODE_AUX_SIZE));  

    graphMap.set('title', getNodeTitle(nodeType, center_x , corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+230,corner_y-80-40));
    graphMap.set('description', getNodeDescription('',1260, corner_y+400));
    if(screenName=='MAIN_GROUP' && nodeCounters.MAIN_GROUP==0)
      nodeCounters.MAIN_GROUP+=1;
    if(screenName=='LOADS' && nodeCounters.LOADS_L==0)
      nodeCounters.LOADS_L+=1;

  }


  if( nodeType=='DC_Generation_Group'){
    let corner_y;
    if(screenName=='MAIN_GROUP'){
      corner_y = init_pos_y + margin_node_groups_y*3 + (nodeCounters.MAIN_GROUP-1)*height_node_space-parseInt(NODE_MAIN_SIZE/2);
      nodeCounters.MAIN_GROUP+=1;
    }else if(screenName=='LOADS'){
      corner_y = init_pos_y + margin_node_groups_y*3 + (nodeCounters.MAIN_GROUP-1)*height_node_space-parseInt(NODE_MAIN_SIZE/2);
      nodeCounters.LOADS_L+=1;
    }
    const corner_x = init_pos_x -parseInt(NODE_MAIN_SIZE/2) ; 
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x +parseInt(NODE_MAIN_SIZE/2);

    nodeCounters.MAIN_GROUP_PV_S+=1;

    graphMap.set('mainGraph', getNodeSprite(resources['solarpanel_w'], corner_x, corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 

    graphMap.set('line', getLinkLine([ [center_x,center_y], [bus_corner_x+parseInt(BUS_WIDTH/2),center_y]]));
    graphMap.set('node', getNodeSprite(resources['link'], bus_corner_x-14+parseInt(BUS_WIDTH/2), center_y-14, 30, 30),false);


    graphMap.set('title', getNodeTitle(nodeType,center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+260, corner_y-60-40));
    graphMap.set('description', getNodeDescription('', 400, corner_y+130,200));

    
  }
  
  

  if( nodeType=='DER_Inverter_PV'){
    let corner_y;

    if (nodeCounters.MAIN_GROUP_PV_I<nodeCounters.MAIN_GROUP_PV_S){
      corner_y = init_pos_y + margin_node_groups_y*3 + (nodeCounters.MAIN_GROUP-1-nodeCounters.MAIN_GROUP_PV_S)*height_node_space+ (nodeCounters.MAIN_GROUP_PV_I)*height_node_space-NODE_SMALL_SIZE/2;
    }else{
      corner_y = init_pos_y + margin_node_groups_y*3 + (nodeCounters.MAIN_GROUP-1)*height_node_space-NODE_SMALL_SIZE/2;
      nodeCounters.MAIN_GROUP+=1;
    }
    
    
    const corner_x = init_pos_x +width_node_space*2-parseInt(NODE_SMALL_SIZE/2);
    const center_y = corner_y+parseInt(NODE_SMALL_SIZE/2);
    const center_x = corner_x+parseInt(NODE_SMALL_SIZE/2);

    nodeCounters.MAIN_GROUP_PV_I+=1;

    graphMap.set('mainGraph', getNodeSprite(resources['dc_to_ac_w'], corner_x,corner_y, NODE_SMALL_SIZE, NODE_SMALL_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_SMALL_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-60,corner_y)); 

    graphMap.set('node', getNodeSprite(resources['link'], bus_corner_x-14+parseInt(BUS_WIDTH/2), center_y-14, 30, 30),false); 
    graphMap.set('line', getLinkLine([ [center_x,center_y], [bus_corner_x-cont_dist_bus,center_y]]));  
    graphMap.set('line2', getLinkLine([  [bus_corner_x-cont_dist_bus+cont_size_x,center_y], [bus_corner_x+parseInt(BUS_WIDTH/2),center_y]])); 

    graphMap.set('title', getNodeTitle(nodeType, center_x , corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+230,corner_y-80-40));
    graphMap.set('description', getNodeDescription('', 1420, corner_y+430));
  
    graphMap.set('StatusLed', getStatusLed(corner_x,corner_y))


    if(screenName=='LOADS' && nodeCounters.LOADS_L==0)
      nodeCounters.LOADS_L+=1;

    //graphMap.set('contactorAnimation', getContactor(bus_corner_x-cont_dist_bus-75,center_y-cont_size_y-cont_margin_box));

  }

  if( nodeType=='DER_Inverter_Contactor'){
    let corner_y;

    if (nodeCounters.MAIN_GROUP_PV_I<nodeCounters.MAIN_GROUP_PV_S){
      corner_y = init_pos_y + margin_node_groups_y*3 + (nodeCounters.MAIN_GROUP-1-nodeCounters.MAIN_GROUP_PV_S)*height_node_space+ (nodeCounters.MAIN_GROUP_PV_I)*height_node_space-NODE_SMALL_SIZE/2;
    }else{
      corner_y = init_pos_y + margin_node_groups_y*3 + (nodeCounters.MAIN_GROUP-1)*height_node_space-NODE_SMALL_SIZE/2;
      nodeCounters.MAIN_GROUP+=1;
    }
    
    
    const corner_x = init_pos_x +width_node_space*2-parseInt(NODE_SMALL_SIZE/2);
    const center_y = corner_y+parseInt(NODE_SMALL_SIZE/2);
    const center_x = corner_x+parseInt(NODE_SMALL_SIZE/2);

    nodeCounters.MAIN_GROUP_PV_I+=1;

    graphMap.set('mainGraph', getNodeSprite(resources['dc_to_ac_w'], corner_x,corner_y, NODE_SMALL_SIZE, NODE_SMALL_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_SMALL_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-60,corner_y)); 

    graphMap.set('contactorAnimation', getContactor(bus_corner_x-cont_dist_bus-75,center_y-cont_size_y-cont_margin_box));
    
    graphMap.set('node', getNodeSprite(resources['link'], bus_corner_x-14+parseInt(BUS_WIDTH/2), center_y-14, 30, 30),false); 
    graphMap.set('line', getLinkLine([ [center_x,center_y], [bus_corner_x-cont_dist_bus,center_y]]));  
    graphMap.set('line2', getLinkLine([  [bus_corner_x-cont_dist_bus+cont_size_x,center_y], [bus_corner_x+parseInt(BUS_WIDTH/2),center_y]])); 

    graphMap.set('title', getNodeTitle(nodeType, center_x , corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+230,corner_y-80-40));
    graphMap.set('description', getNodeDescription('', 1420, corner_y+430));

    if(screenName=='LOADS' && nodeCounters.LOADS_L==0)
      nodeCounters.LOADS_L+=1;

    

  }

  if( nodeType=='PV_Logger'){

    const corner_y = init_pos_y + margin_node_groups_y*3 + (nodeCounters.MAIN_GROUP-Math.max(nodeCounters.MAIN_GROUP_PV_I,nodeCounters.MAIN_GROUP_PV_S)-2)*height_node_space-parseInt(NODE_AUX_SIZE/2);
    const corner_x = init_pos_x +width_node_space*2-parseInt(NODE_AUX_SIZE/2);
    const center_y = corner_y+parseInt(NODE_AUX_SIZE/2);
    const center_x = corner_x+parseInt(NODE_AUX_SIZE/2);
    graphMap.set('mainGraph', getNodeSprite(resources['meter_w'], corner_x,corner_y, NODE_AUX_SIZE,NODE_AUX_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_AUX_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-60,corner_y-15)); 

    const height=(Math.max(nodeCounters.MAIN_GROUP_PV_I,nodeCounters.MAIN_GROUP_PV_S)+0.5)*320
    graphMap.set('line', getLine([ [corner_x-100,center_y], [corner_x+760,center_y], [corner_x+760,center_y+height], [corner_x-100,center_y+height], [corner_x-100,center_y] ],4,0x808080 ));
    graphMap.set('title', getNodeTitle(nodeType, center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+230-20,corner_y-80-20-40));
    graphMap.set('description', getNodeDescription('', 1420, corner_y+430));

    
  }

  if( nodeType=='AC_Generation_Group'){
    let corner_y;
    if(screenName=='MAIN_GROUP'){
      corner_y = 800+nodeCounters.MAIN_GROUP*440;
      nodeCounters.MAIN_GROUP+=1;
    }else if(screenName=='LOADS'){
      corner_y = 600+nodeCounters.LOADS_L*440;
      nodeCounters.LOADS_L+=1;
    }
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);
    
    graphMap.set('mainGraph', getNodeSprite('solarpanel_w', 100, corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(100, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(100-50,corner_y-15)); 

    graphMap.set('inverter', getNodeSprite('dc_to_ac_w', 1080+20, center_y-80, NODE_AUX_SIZE, NODE_AUX_SIZE));
    graphMap.set('inverterBk', getNodeBackground(1080+20, center_y-80, NODE_AUX_SIZE));
    graphMap.set('node', getNodeSprite('link', 1670-20, center_y-20, 40, 40));
    graphMap.set('line', getLinkLine([ [210,center_y], [1670,center_y], ]));
    const corner_x_bus=bus_corner_x;
    const corner_y_bus=710-BUS_WIDTH;
    graphMap.set('lineBus', getLinkLineBus(corner_x_bus,corner_y_bus,center_y-710+BUS_WIDTH*2,BUS_WIDTH,'top',2,true));  
    graphMap.set('title', getNodeTitle(nodeType, 100, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(400, corner_y-90-40));
    graphMap.set('description', getNodeDescription('', 400,  corner_y+130));
    graphMap.set('moreInfoBtn_ac', getNodeMoreInfoBtn(100+200, corner_y+180));

  }

  if( nodeType=='AC_Storage_Group'){
    let corner_y;
    if(screenName=='MAIN_GROUP'){
      corner_y = 600+nodeCounters.MAIN_GROUP*440;
      nodeCounters.MAIN_GROUP+=1;
    }else if(screenName=='LOADS'){
      corner_y = 600+nodeCounters.LOADS_L*440;
      nodeCounters.LOADS_L+=1;
    }
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);
    graphMap.set('mainGraph', getNodeSprite('battery_w', 100, corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(50, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(100-50,corner_y-15)); 
    
    graphMap.set('inverter', getNodeSprite('dc_to_ac_w', 1080+20, center_y-80, NODE_AUX_SIZE, NODE_AUX_SIZE));
    graphMap.set('inverterBk', getNodeBackground(1080+20, center_y-160, NODE_AUX_SIZE));
    graphMap.set('node', getNodeSprite('link', 1670-20, center_y-20, 40, 40));
    graphMap.set('line', getLinkLine([ [250,center_y], [1670,center_y]]));
    const corner_x_bus=bus_corner_x;
    const corner_y_bus=710-BUS_WIDTH;
    graphMap.set('lineBus', getLinkLineBus(corner_x_bus,corner_y_bus,center_y-710+BUS_WIDTH*2,BUS_WIDTH,'top',2,true)); 
    graphMap.set('title', getNodeTitle(nodeType, 100, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(400, corner_y-90-40));
    graphMap.set('description', getNodeDescription('', 400, corner_y+130));
    graphMap.set('moreInfoBtn_ac', getNodeMoreInfoBtn(100+200, corner_y+180));

  }
  
  
  if( nodeType=='LOAD_Dispatched'){
    const corner_y = init_pos_y + margin_node_groups_y +(nodeCounters.MAIN_GROUP)*height_node_space-parseInt(NODE_MAIN_SIZE/2);
    const corner_x = init_pos_x + width_node_space -parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x+parseInt(NODE_MAIN_SIZE/2);
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);

    nodeCounters.MAIN_GROUP+=1;
    nodeCounters.MAIN_GROUP_LOADS+=1;
    const corner_x_bus=bus_corner_x;

    graphMap.set('mainGraph', getNodeSprite(resources['load_ev_w'], corner_x, corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 

    graphMap.set('node', getNodeSprite(resources['link'], corner_x_bus+14,center_y-14, 30, 30));
    graphMap.set('line', getLinkLine([ [corner_x+170,center_y], [corner_x_bus+7,center_y] ]));

    graphMap.set('title', getNodeTitle(nodeType,center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+260, corner_y-60-40));
    graphMap.set('description', getNodeDescription('', corner_x+300, corner_y));

  }
  if( nodeType=='LOAD_Hydroscrew'){
    const corner_y = init_pos_y + margin_node_groups_y +(nodeCounters.MAIN_GROUP)*height_node_space-parseInt(NODE_MAIN_SIZE/2);
    const corner_x = init_pos_x + width_node_space -parseInt(NODE_MAIN_SIZE/2);
    const center_x = corner_x+parseInt(NODE_MAIN_SIZE/2);
    const center_y = corner_y+parseInt(NODE_MAIN_SIZE/2);

    nodeCounters.MAIN_GROUP+=1;
    nodeCounters.MAIN_GROUP_LOADS+=1;
    const corner_x_bus=bus_corner_x;

    graphMap.set('mainGraph', getNodeSprite(resources['hidroscrew'], corner_x, corner_y, NODE_MAIN_SIZE, NODE_MAIN_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_MAIN_SIZE));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 

    graphMap.set('node', getNodeSprite(resources['link'], corner_x_bus+14,center_y-14, 30, 30));
    graphMap.set('line', getLinkLine([ [corner_x+170,center_y], [corner_x_bus+7,center_y] ]));

    graphMap.set('title', getNodeTitle(nodeType,center_x, corner_y-70));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+260, corner_y-60-40));
    graphMap.set('description', getNodeDescription('', corner_x+300, corner_y));

  }

  if( nodeType=='ENFYO_controller'){
    const corner_y = 70;
    const corner_x = 50;
   // const center_x = corner_x+parseInt(NODE_SMALL_SIZE/2);
    graphMap.set('mainGraph', getNodeSprite(resources['enfyo_w'], corner_x, corner_y, NODE_SMALL_SIZE, NODE_SMALL_SIZE,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_SMALL_SIZE));
    
    graphMap.set('title', getNodeTitle(nodeType,corner_x, corner_y-60,0));
    graphMap.set('kpiWindow', new KpiWindow(corner_x+190, corner_y+10,670));
    graphMap.set('alarm', getAlarm(corner_x-50,corner_y-15)); 
  }

  if( nodeType=='Gateway'){
    const corner_y = 360;
    const corner_x = 90+nodeCounters.MAIN_GROUP_GW*240;
    const center_x = corner_x+parseInt(NODE_SMALL_SIZE/4);
    graphMap.set('mainGraph', getNodeSprite(resources['enfyo_w'], corner_x, corner_y, NODE_SMALL_SIZE/2, NODE_SMALL_SIZE/2,true));
    graphMap.set('mainGraphBk', getNodeBackground(corner_x, corner_y, NODE_SMALL_SIZE/2));
    graphMap.set('alarm', getAlarm(corner_x-60,corner_y+15)); 
    graphMap.set('title', getNodeTitle(nodeType,center_x, corner_y-50));
    nodeCounters.MAIN_GROUP_GW+=1;
  }

 
  if(graphMap.size)
    return graphMap;
  return undefined;
}